import { render, staticRenderFns } from "./ThreeFabricDisclaimer.vue?vue&type=template&id=0e541ac4&scoped=true&"
import script from "./ThreeFabricDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./ThreeFabricDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./ThreeFabricDisclaimer.vue?vue&type=style&index=0&id=0e541ac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e541ac4",
  null
  
)

export default component.exports